/*******************************************************************************
* @ngdoc    service
* @name     csm.books.nsf.service:Services
* @description
* Contains the services used exclusively by this application.
*******************************************************************************/
/* @ngInject */ export function NsfChecksServiceProvider() {
  this.httpServiceBase = '/books/nsfChecks/';
  this.httpServices = {
    drop: function (id) {
      return this.get('drop/{0}'.format(id));
    },
    findChecks: function (filter) {
      return this.post('findChecks', filter);
    },
    findFines: function (name) {
      return this.get('findFines/{0}'.format(name));
    },
    findNSFChecks: function (filter) {
      return this.post('findNSFChecks', filter);
    },
    getAccounts: function () {
      return this.post('getAccounts');
    },
    getCheck: function (id, getSF, isReview) {
      return this.get('getCheck/{0}/{1}/{2}'.format(id, getSF, isReview));
    },
    getNSF: function (id, dir) {
      return this.get('getNSF/{0}/{1}'.format(id, dir));
    },
    save: function (nsf) {
      return this.post('save', nsf);
    }
  };

  /**
   * @ngdoc       service
   * @name        ReceiptsService
   * @module      csm.books.WriteReceipts
   * @description Receipts controller services.
   */
  this.$get = ['HTTPService', function (HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
};
